import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/category/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/category/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/category/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/category/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/category/delete/${id}`)
}

// 根据ID查询
export function queryById (id) {
  return request.get(`/business/category/${id}`)
}

// 修改状态
export function updateDisableById (data) {
  return request.post('/business/category/updateDisableById', data)
}

// 平台分类列表
export function baseCategoryList (data) {
  return request.post('/business/category/baseCategoryList', data)
}

// 企业新建分类
export function companyCreate (data) {
  return request.post('/business/category/companyCreate', data)
}

// 企业根据ID修改
export function companyUpdateById (data) {
  return request.post('/business/category/companyUpdateById', data)
}

// 表 - H5
export function list (data) {
  return request.post('/business/category/list', data)
}

export function fetchTree (data) {
  return request.post('/business/category/tree', data || {})
}

export function fetchChildren (parentId) {
  return request.get(`/business/category/children/${parentId}`)
}

export function createSub (data) {
  return request.post('/business/category/createSub', data)
}

export function updateSub (data) {
  return request.post('/business/category/updateSub', data)
}

export function deleteSub (id) {
  return request.get(`/business/category/deleteSub/${id}`)
}